import { loadTasks, loadTodaysTasks, loadTask, loadTaskAssocs } from "../common/api";

const model = {
    name: 'tasks',
    state: { 
        all: [], 
        current: {
            details: {},
            associations: []
         },
         currentId: '',
         byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.tid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.tid]: { 
                        ...state.byId[payload.tid],
                        ...payload.cdc 
                    }
                }
            }
        },
        cdcInsertAssoc: ( state, payload ) => {
            const [ tid, oid ] = payload.tid.split( '#' );
            let assoc = [ payload.cdc ];

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [tid]: { 
                        ...state.byId[tid],
                        assoc: assoc
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.tid]: {
                        ...state.byId[payload.tid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.tid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedTasks: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        },
        resetCurrent: ( state ) => {
            return {
                ...state,
                current: {
                    details: {},
                    associations: []
                }
            }
        },
        loadedCurrent: ( state, payload ) => {
            return { 
                ...state,
                current: {
                    ...state.current,
                    details: { ...payload }
                }
            }
        },
        loadedCurrentAssocs: ( state, payload ) => {
            return { 
                ...state,
                current: {
                    ...state.current,
                    associations: [ ...payload ]
                }
            }
        },
        loadedAll: ( state, payload ) => {
            return {
                ...state,
                all: [ ...payload ]
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadTodaysTasks( { aid, uid } ) {
            const list = await loadTodaysTasks( aid, uid, 'all' );
            dispatch.tasks.loadedAll( list );
        },
        async loadTask( { aid, uid, tid } ) {
            dispatch.tasks.resetCurrent();
            const t = await loadTask( aid, uid, tid );
            dispatch.tasks.loadedCurrent( t );
        },
        async loadTaskAssocs( { aid, uid, tid } ) {
            const tas = await loadTaskAssocs( aid, uid, tid );
            dispatch.tasks.loadedCurrentAssocs( tas );
        },
        async loadTasks( { aid, uid } ) {
            const list = await loadTasks( aid, uid );
            let byId = {};
            list.forEach( l => byId[l.tid] = l );
            dispatch.tasks.loadedTasks( byId );
        },
        insert( { tid, cdc } ) {
            const member = tid.match( '#' );
            if ( member ) {
                dispatch.tasks.cdcInsertAssoc( { tid, cdc } );
            } else {
                dispatch.tasks.cdcInsert( { tid, cdc } );
            }
        },
        modify( { tid, cdc } ) {
            dispatch.tasks.cdcModify( { tid, cdc } );
        },
        remove( { tid } ) {
            dispatch.tasks.cdcRemove( { tid } );
        },
        setCurrent( { tid } ) {
            dispatch.tasks.setCurrentId( { tid } );
        }
    } )
}

export default model;